import React, { Fragment } from 'react';
import classNames from 'classnames';
import Slide from './Slide';
import Overlay from './Overlay';
import SlideHeading from './SlideHeading';
import ProjectsNav from './ProjectsNav';
import MobileSlide from './MobileSlide'
import main_navigation from '../resources/navbackgrounds/main.jpg';

import slideStyles from './css-modules/slide.module.css';

import ProjectTitle from '../slide-components/Project_Title';
import ProjectTitleBack from '../resources/backgrounds/Main Title.jpg';

import main from '../resources/navbackgrounds/main.jpg';
import political from '../resources/navbackgrounds/political.jpg';
import twomurders from '../resources/navbackgrounds/twomurders.jpg';
import mallroad from '../resources/navbackgrounds/mallroad.jpg';
import literary from '../resources/navbackgrounds/literary.jpg';
import hindu from '../resources/navbackgrounds/hindu.jpg';
import overlayBg from '../resources/MapBG.jpg';

import plotreeFull from '../resources/logo.png';

//Mobile Imports to follow ******************
import ProjectTitleMobile from './mobile-components/Project_Title_Mob';
import ProjectsNavMobile from './mobile-components/ProjectsNavMobile';

import MobileSectionTitle from './mobile-components/MobileSectionTitle';

//Mobile Imports Before this comment ********

const imageArr = [ProjectTitleBack,main_navigation,main,political,twomurders,mallroad,literary,hindu,plotreeFull, overlayBg];

const mobileImageArr = imageArr;

const slideMap = {
  "home" : {
    name : "Women Action Forum",
    slides : {
      "home" : {
        component : (
          <Slide bgImage={ProjectTitleBack}>
            {(props) => {
              return (
                <div className={slideStyles.slidefull_container}>
                  <div onClick={()=> props.setDisplayedOverlay(["1",0])} className={slideStyles.about_container}>
                    <p className={slideStyles.about_text}>About</p>
                  </div>
                  <div className={slideStyles.slideflex} ref={props.addParallaxAndFadeRef(10)}>
                    <div className={slideStyles.slideContent}>
                      <ProjectTitle
                        optionalLogo={plotreeFull}
                        present=""
                        title="Walking in the City"
                        subtitle="Mapping Lahore's Cultural and Social History"
                        description="An interactive website featuring student-led research projects on various aspects of Lahore's history and everyday life."
                      />
                    </div>
                  </div>
                  <Overlay
                    oId="1"
                    displayedOverlay={props.displayedOverlay}
                    closeOverlay={props.closeOverlay}
                    setDisplayedOverlay={props.setDisplayedOverlay}
                  />
                </div>
              )}}
          </Slide>
        ),
        prev : "projects",
        next : "projects",
        menuInverted : false,
        hideChapterNumber: true,
        bottomBarMessage: '',
        hideVerticalNav: true,
      },
    }
  },
  "chapter1" : {
    name : "Chapter 1: Background",
    slides : {
      "projects" : {
        component : (
          <Slide bgImage={main_navigation}>
            {(props) => {
              return (
                <div className={slideStyles.slidefull_container}>
                  <div onClick={()=> props.setDisplayedOverlay(["1",0])} className={classNames(slideStyles.about_container, slideStyles.about_container_light)}>
                    <p className={slideStyles.about_text}>About</p>
                  </div>
                <ProjectsNav projectNavOpen={true} hideCloseButton disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>/>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                />
              </div>
              )}}
          </Slide>
        ),
        prev : "home",
        next : "projects",
        menuInverted : true,
        hideChapterNumber: true,
        hideVerticalNav: true,
        bottomBarMessage: ''
      }
    }
  }
}

function topoSortSlides(slides){
  const visitedSet = {};
  const orderArr = [];
  const allSlidesMap = {};

  for(let i in slides){
    for(let j in slides[i].slides){
      allSlidesMap[j] = slides[i].slides[j];
    }
  }

  Object.keys(allSlidesMap).forEach((s)=>{
    topoSortNode(s, allSlidesMap, orderArr, visitedSet)
  })
  return orderArr.reverse().reduce((acc,d,i)=>{
    acc[d] = i;
    return acc;
  },{});
}

function topoSortNode(nodename,nodes, orderArr, visitedSet){
  if(nodename === null || visitedSet[nodename]){
    return orderArr;
  }

  visitedSet[nodename] = true;
  topoSortNode(nodes[nodename].next, nodes, orderArr, visitedSet);
  orderArr.push(nodename);

  return orderArr;
}

const slideOrder = topoSortSlides(slideMap)

const chapterArr = ["chapter1","chapter2","chapter3","chapter4"]

const mobileSlideMap = {
  "home" : {
    name: "Project Home",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <div onClick={()=> props.setDisplayedOverlay(["1",0])} className={slideStyles.about_container}>
                  <p className={slideStyles.about_text}>About</p>
                </div>
                <ProjectTitleMobile
                  image={ProjectTitleBack}
                  optionalLogo={plotreeFull}
                  present=""
                  title="Walking in the City"
                  subtitle="Mapping Lahore's Cultural and Social History"
                  description="An interactive website featuring student-led research projects on various aspects of Lahore's history and everyday life."
                />
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                />
              </div>
              )
          }
        }
      </MobileSlide>
    )
  },
  "projects" : {
    name: "Browse Projects",
    component : (
      <MobileSlide>
        {
          (props)=>{
            return (
              <div>
                <div onClick={()=> props.setDisplayedOverlay(["1",0])} className={classNames(slideStyles.about_container, slideStyles.about_container_light)}>
                  <p className={slideStyles.about_text}>About</p>
                </div>
                <ProjectsNavMobile projectNavOpen={true} hideCloseButton disclaimer=<span>These projects are based on research conducted by students for the course <i>Walking in the City: Mapping Everyday Life in Lahore.</i></span>/>
                <Overlay
                  oId="1"
                  displayedOverlay={props.displayedOverlay}
                  closeOverlay={props.closeOverlay}
                  setDisplayedOverlay={props.setDisplayedOverlay}
                />
              </div>
            )
          }
        }
      </MobileSlide>
    ),
    menuInverted : true
  }
}

export {
    slideMap,
    slideOrder,
    imageArr,
    chapterArr,
    mobileSlideMap,
    mobileImageArr
};
